import React from "react";

import styles from "./Textile.module.scss";

const Textile: React.FC = () => {
  return (
    <section className={styles.textile}>
      <div className="container">
        <div className={styles.body}>
          <div className={styles.item}>
            <div className={styles.image}>
              <img src="/img/main/sales-and-news/1.jpg" alt="textile" />
            </div>
            <h3 className={styles.title}>Трикотаж: все, что нужно знать о самой универсальной ткани</h3>
          </div>
          <div className={styles.item}>
            <div className={styles.image}>
              <img src="/img/main/sales-and-news/2.jpg" alt="textile" />
            </div>
            <h3 className={styles.title}>Фатин: легкость, пышность и универсальность</h3>
          </div>
          <div className={styles.item}>
            <div className={styles.image}>
              <img src="/img/main/sales-and-news/3.jpg" alt="textile" />
            </div>
            <h3 className={styles.title}>Особенности льна в шитье: плюсы и минусы</h3>
          </div>
          <div className={styles.item}>
            <div className={styles.image}>
              <img src="/img/main/sales-and-news/4.jpg" alt="textile" />
            </div>
            <h3 className={styles.title}>Поплин - что за ткань и для чего этот материал</h3>
          </div>
        </div>
        <div className={styles.button}>
          <button>Посмотреть еще</button>
        </div>
      </div>
    </section>
  );
};

export default Textile;
